import API_BASE from './config';

export function getLivePositions() {
    return fetch(`${API_BASE}/live-race/positions`, { headers: { 'Accept': 'application/json' } })
        .then((res) => {
            if (!res.ok) throw new Error('Network response not ok');
            return res.json();
        });
}
